// extracted by mini-css-extract-plugin
module.exports = {"paper":"MobileNav_paper__1K2-u","header":"MobileNav_header__1IXqC","logo":"MobileNav_logo__1jMOg"};